import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { AppState } from '../../../../@store/app.reducers';
import { Store } from '@ngrx/store';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalConsultarTercerosComponent } from '../../@modals/modal-consultar-terceros/modal-consultar-terceros.component';
import { ModalConsultarLesionadosComponent } from '../../@modals/modal-consultar-lesionados/modal-consultar-lesionados.component';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction, MostrarMensajeExitoAction } from '../../../../@store/actions';
import { ConsultaSiniestroOutput, RecuperacionPago, TerceroComplemento } from '../../../../models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { importeMayorACeroValidator } from '../../@validators/validators-complemento';
import { NgClass, SlicePipe } from '@angular/common';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';

@Component({
    selector: 'app-crear-actualizar-pagos-recuperaciones',
    templateUrl: './crear-actualizar-pagos-recuperaciones.component.html',
    styleUrls: ['./crear-actualizar-pagos-recuperaciones.component.scss'],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatMiniFabButton, MatIcon, MatError, MatSelect, MatOption, FormatoNumeroMonedaCoplementoWebDirective, UpperCaseTextDirective, OnlyNumber, SlicePipe]
})
export class CrearActualizarPagosRecuperacionesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('pagos') paginator: MatPaginator;

  @Input() public datosPagosRecuperaciones: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() public seccion: number;

  @Output() eventosPagosRecuperaciones = new EventEmitter<{ nombre: string, valor: any }>();

  public displayColumns = ['TipoTercero', 'Tipo', 'Vehiculo', 'Compañia', 'Importe', 'Acciones'];

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };
  public tamanoResultados: number = 0;
  public formPagos: FormGroup;
  public pagoRecuperacion = null;
  public habilitaAsegurado = false;
  public listaObservables = new Subscription();
  public formSubscripciones = new Subscription();

  public siniestroConsultado: string;
  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public detalleRecuperacionPago: RecuperacionPago;

  public catTipos = [];
  public catSubtipos = [];
  public catCoberturas = [];
  public catConsultaTradicionalTipo = [];
  public catCompanias = [];

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.crearFormulario();
    this.obtenerReduxState();
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.obtenerCatalogos();
    this.cambiosFormularios();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;
    });
    this.listaObservables.add(subsComplemento);
  }


  obtenerCatalogos() {
    this.store.select(selectListaCatalogosSiniestros).subscribe({
      next: (value) => {
        this.catConsultaTradicionalTipo = value.consultaTradicionalTipo;
      },
    });
  }

  crearFormulario() {
    this.formPagos = new FormGroup({
      tipoTercero: new FormControl({ value: null, disabled: true }),
      descripcionTercero: new FormControl({ value: null, disabled: true }),
      coberturaTercero: new FormControl({ value: null, disabled: true }),
      claveCoberturaTercero: new FormControl({ value: null, disabled: true }),
      tipo: new FormControl(null, Validators.required),
      folio: new FormControl(null),
      subTipo: new FormControl(null),
      importe: new FormControl({ value: null, disabled: true }),
      lesionado: new FormControl({ value: null, disabled: true }),
      nombreLesionado: new FormControl(null),
      apellidoPaterno: new FormControl(null),
      apellidoMaterno: new FormControl(null),
      edad: new FormControl(null),
      tradicionalTipo: new FormControl(null),
      compania: new FormControl({ value: null, disabled: true }),
      descripcionCompania: new FormControl({ value: null, disabled: true }),
      coberturaIngreso: new FormControl(null),

      idTercero: new FormControl(null),
      idLesionado: new FormControl(null),
      subtipoPagoGarantia: new FormControl(null)
    });
  }

  cambiosFormularios() {
    this.formSubscripciones.unsubscribe();
    this.formSubscripciones = new Subscription();

    const subsTipo = this.formPagos.get('tipo')?.valueChanges.subscribe({
      next: (value) => {
        if (!value) {
          this.formPagos.get('subTipo').setValue(null, { onlySelf: true });
          return
        };
        this.consultaTiposPagos();
        if ([5, 6, 10].includes(value)) {
          this.formPagos.get('subTipo')?.setValidators(Validators.required);
          this.formPagos.get('subTipo')?.updateValueAndValidity();
        } else {
          this.formPagos.get('subTipo')?.setValidators(null);
          this.formPagos.get('subTipo')?.updateValueAndValidity();
        }
        const validaInmueble = this.validaCompaniaInmueble(this.detalleRecuperacionPago?.cve_cobertura?.toString(), this.detalleRecuperacionPago?.estatus_tercero, this.detalleRecuperacionPago?.tipo_tercero);
        //Valida tecero inmueble
        if ([5, 6].includes(value) && validaInmueble) {
          this.formPagos.get('compania')?.setValidators(Validators.required);
          this.formPagos.get('compania')?.updateValueAndValidity();
        } else {
          this.formPagos.get('compania')?.setValidators(null);
          this.formPagos.get('compania')?.updateValueAndValidity();
        }

        if (this.seccion == 2 && [6].includes(this.formPagos.get('tipo')?.value)) {
          this.formPagos.get('tradicionalTipo')?.setValidators(Validators.required);
          this.formPagos.get('tradicionalTipo')?.updateValueAndValidity();
          this.formPagos.get('tradicionalTipo')?.enable();
          // Se cambia el valor original a 1
        } else {
          this.formPagos.get('tradicionalTipo')?.disable();
          this.formPagos.get('tradicionalTipo')?.setValue(0);
          this.formPagos.get('tradicionalTipo')?.setValidators(null);
          this.formPagos.get('tradicionalTipo')?.updateValueAndValidity();
        }

        // Pago daños
        if (value == 11) {
          this.formPagos.get('importe')?.enable();
          // this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          // this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
        } else {
          this.formPagos.get('importe')?.disable();
          // this.formPagos.get('coberturaIngreso')?.setValidators(null);
          // this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
        }

        this.consultaSubTiposPagos(value, this.detalleRecuperacionPago?.estatus_tercero, this.detalleRecuperacionPago?.tipo_tercero);
      },
    });
    const subsSubtipo = this.formPagos.get('subTipo')?.valueChanges.subscribe({
      next: (value) => {
        console.log(value)
        if (!value) return;
        this.consultaCoberturasXTiposPagos(this.formPagos.get('tipo').value, value, this.detalleRecuperacionPago?.id_tercero || 0, this.detalleRecuperacionPago?.num_liga || undefined);

        //Sipac
        if ([1, 2].includes(value) && [5, 7].includes(this.formPagos.get('tipo').value)) {
          this.consultarImporte(value);
          this.formPagos.get('folio')?.setValidators(Validators.required);
          this.formPagos.get('folio')?.updateValueAndValidity();
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();

          this.formPagos.get('importe')?.disable();
          this.formPagos.get('compania')?.disable();
        } else {
          this.formPagos.get('folio')?.setValidators(null);
          this.formPagos.get('folio')?.updateValueAndValidity();
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();

          this.formPagos.get('importe')?.enable();
          this.formPagos.get('compania')?.enable();
        }

        // Pago daños 
        if (value == 3 && this.formPagos.get('tipo').value == 11) {
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
        } else {
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
        }

        // Orden directa y pase médico
        if (value == 3 && this.formPagos.get('tipo').value == 10) {
          this.formPagos.get('compania')?.disable();
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
          this.formPagos.get('lesionado')?.setValidators(Validators.required);
          this.formPagos.get('lesionado')?.updateValueAndValidity();
        } else {
          this.formPagos.get('compania')?.enable();
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
          this.formPagos.get('lesionado')?.setValidators(null);
          this.formPagos.get('lesionado')?.updateValueAndValidity();
        }

        // Orden directa y volante reparación
        if (value == 4 && this.formPagos.get('tipo').value == 10) {
          this.formPagos.get('compania')?.disable();
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
        } else {
          this.formPagos.get('compania')?.enable();
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
        }

        // Tradicional y volante de reparación
        if (value == 4 && this.formPagos.get('tipo').value == 6) {
          // this.formPagos.get('compania')?.disable();
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
        } else {
          // this.formPagos.get('compania')?.enable();
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
        }

        // Tradicional y pase medico
        if (value == 3 && this.formPagos.get('tipo').value == 6) {
          // this.formPagos.get('compania')?.disable();
          this.formPagos.get('coberturaIngreso')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('importe')?.updateValueAndValidity();
          this.formPagos.get('nombreLesionado')?.setValidators(Validators.required);
          this.formPagos.get('nombreLesionado')?.updateValueAndValidity();
          this.formPagos.get('apellidoPaterno')?.setValidators(Validators.required);
          this.formPagos.get('apellidoPaterno')?.updateValueAndValidity();
          this.formPagos.get('apellidoMaterno')?.setValidators(Validators.required);
          this.formPagos.get('apellidoMaterno')?.updateValueAndValidity();
          this.formPagos.get('edad')?.setValidators(Validators.required);
          this.formPagos.get('edad')?.updateValueAndValidity();
          this.formPagos.get('compania')?.setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formPagos.get('compania')?.updateValueAndValidity();
        } else {
          // this.formPagos.get('compania')?.enable();
          this.formPagos.get('coberturaIngreso')?.setValidators(null);
          this.formPagos.get('coberturaIngreso')?.updateValueAndValidity();
          this.formPagos.get('importe')?.setValidators(null);
          this.formPagos.get('importe')?.updateValueAndValidity();
          this.formPagos.get('apellidoPaterno')?.setValidators(null);
          this.formPagos.get('apellidoPaterno')?.updateValueAndValidity();
          this.formPagos.get('apellidoMaterno')?.setValidators(null);
          this.formPagos.get('apellidoMaterno')?.updateValueAndValidity();
          this.formPagos.get('edad')?.setValidators(null);
          this.formPagos.get('edad')?.updateValueAndValidity();
          this.formPagos.get('compania')?.setValidators(null);
          this.formPagos.get('compania')?.updateValueAndValidity();
        }
      },
    });
    this.formSubscripciones.add(subsTipo);
    this.formSubscripciones.add(subsSubtipo);
    // this.listaObservables.add(subCobertura);
  }

  creaPagoRecuperacion() {
    this.habilitaAsegurado = true;
    if (this.pagoRecuperacion == null ) {
      this.catCoberturas = this.detalleSiniestroCompleto.Coberturas;
      const descCobertura = this.cargaCoberturaAsegurado(this.seccion, this.catCoberturas);
      const claveCobertura = this.cargaIdCoberturaAsegurado(this.seccion, this.catCoberturas);
      this.formPagos.get('claveCoberturaTercero').setValue(claveCobertura);
      this.formPagos.get('coberturaTercero').setValue(descCobertura);
    }
  }

  abrirSeccionPagoRecuperacion(tercero?: RecuperacionPago) {
    this.habilitaAsegurado = true;
    if (tercero) {
      this.pagoRecuperacion = tercero;
      this.consultarPagosRecuperacionesIndividual(tercero.num_liga);
    }
  }

  regresaConsulta() {
    this.habilitaAsegurado = false;
    this.pagoRecuperacion = null;
    this.catCoberturas = [];
    this.catTipos = [];
    this.catSubtipos = [];
    this.catCompanias = [];
    this.detalleRecuperacionPago = null;
    this.crearFormulario();
    this.cambiosFormularios();
  }

  abrirModalTiposTerceros() {
    //TODO: Parametros
    const dialog = this.dialog.open(ModalConsultarTercerosComponent, {
      width: '650px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { modulo: 'R&P', tipoTercero: null },
    }).afterClosed().subscribe((data: TerceroComplemento) => {
      if (data) {
        this.procesaSeleccionTercero(data);
      }
    });
  }

  procesaSeleccionTercero(data: TerceroComplemento) {
    console.log(data)
    const coberturaTer = data.cobertura_tercero ?? 0;
    const descripcionTer = data.tipo_tercero == 1 ? data?.placas : data?.desc_tipo_tercero;
    const companiaTer = data?.cve_cia_aseg ?? 0;

    this.detalleRecuperacionPago = data as any;
    this.detalleRecuperacionPago.cve_cia_aseg = data?.cve_cia_aseg ?? 0;
    this.detalleRecuperacionPago.cve_cia_aseg_sipac = data?.cve_cia_aseg_sipac ?? 0;
    this.detalleRecuperacionPago.desc_cia_aseg = data?.desc_cia_aseg ?? '0';
    this.detalleRecuperacionPago.estatus_tercero = data.estatus_tercero;
    this.detalleRecuperacionPago.tipo_tercero = data.tipo_tercero;
    this.detalleRecuperacionPago.id_tercero = data.id_tercero;
    this.detalleRecuperacionPago.cve_cobertura = data.cobertura_tercero ?? 0;
    
    console.log(this.detalleRecuperacionPago)

    this.formPagos.get('compania').setValue(companiaTer);
    this.formPagos.get('descripcionCompania').setValue(data?.desc_cia_aseg);
    this.formPagos.get('coberturaIngreso').setValue(coberturaTer);


    const descCobertura = this.cargaCoberturaAsegurado(this.seccion, this.catCoberturas);
    const idCobertura = this.cargaIdCoberturaAsegurado(this.seccion, this.catCoberturas);
    this.detalleRecuperacionPago.cve_cobertura = idCobertura;
    this.formPagos.get('claveCoberturaTercero').setValue(idCobertura);
    this.formPagos.get('coberturaTercero').setValue(descCobertura);

    this.formPagos.patchValue({
      descripcionTercero: descripcionTer,
      tipoTercero: data.tipo_tercero,
      idTercero: data.id_tercero,
      tipo: null
    })

    this.consultaTiposPagos();
    this.consultaSubTiposPagos(0, data.estatus_tercero, data.tipo_tercero);
    this.consultaCoberturasXTiposPagos(0, 0, data.id_tercero, undefined);
  }

  abrirModalLesionados() {
    const dialog = this.dialog.open(ModalConsultarLesionadosComponent, {
      width: '600px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { tipoCliente: this.detalleSiniestroBase.responsabilidad, id_tercero : this.formPagos.getRawValue()?.idTercero },
    }).afterClosed().subscribe(data => {
      console.log(data, 'seleccion')
      if (data) {
        const nombreLesionado = data?.nombre?.split("|");
        console.log(data)
        this.formPagos.patchValue({
          nombreLesionado: nombreLesionado ? nombreLesionado[0] : null,
          apellidoPaterno: nombreLesionado ? nombreLesionado[1] : null,
          apellidoMaterno: nombreLesionado ? nombreLesionado[2] : null,
          idLesionado: data?.id_lesionado || 0,
          lesionado: data.nombre?.replace(/\|/g, " ")
        })
      }
    });
  }

  consultarImporte(subTipo: number) {
    const request = {
      subTipo: subTipo
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaImporteSipac(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado?.Importe?.length && value.Exito) {
          this.formPagos.patchValue({
            importe: value.Resultado.Importe?.replace(/[$,]/g, "")
          });
        } else {
          // NOTE: Se comentó
          // this.procesosComunesService.alertaGeneralComplemento('Aviso!', '', 'warning', false, true, `${value.Mensaje}`)
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener el detalle del importe.' }));
      },
    })
  }

  consultaCoberturasXTiposPagos(tipoPago: number = 0, subTipo: number = 0, idTercero: number | undefined, numeroLiga: number | undefined) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: this.seccion,
      tipoPago,
      subtipoPago: subTipo,
      IdTercero: idTercero,
      numeroLiga: numeroLiga
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaCoberturasXTipoySubtipoPagos(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value?.Resultado?.CoberturasC != null && ![10, 11].includes(tipoPago)) {
          this.catCoberturas = value.Resultado.CoberturasC;
        }
        if (this.catCoberturas.length == 0) {
          if (value.Mensaje.length > 0 && value.MensajeSistema == null) this.procesosComunesService.alertaGeneralComplemento('Aviso!', '', 'warning', false, true, `${value.Mensaje}`);
          this.catCoberturas = value.Resultado?.CoberturasC ?? [];
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener el detalle del importe.' }));
      },
    })
  }

  consultaTiposPagos() {
    const coberturaClaveTercero = this.detalleRecuperacionPago?.cve_cobertura ?? 0;
    const estatus = this.detalleRecuperacionPago?.estatus_tercero;
    const request = {
      tipoCliente: this.detalleSiniestroBase.responsabilidad,
      tipoTercero: this.detalleRecuperacionPago?.tipo_tercero,
      estatusTercero: estatus,
      cobertura: coberturaClaveTercero || 0,
      compania: this.detalleRecuperacionPago?.cve_cia_aseg
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaTiposPagos(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.catTipos = value.Resultado?.TiposPagos || [];
        this.catCompanias = value.Resultado?.Companias || [];
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  consultaSubTiposPagos(tipoPago: number, estatusTercero?: number, tipoDeTercero?: number) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroConsultado);
    const estatus = estatusTercero ?? this.detalleRecuperacionPago?.estatus_tercero;
    const tipoTercero = tipoDeTercero ?? this.detalleRecuperacionPago?.tipo_tercero;
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoPago: tipoPago,
      estatusTercero: estatus,
      tipoTercero: tipoTercero
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaSubTiposPagos(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.catSubtipos = value.Resultado?.SubTiposPagos || [];
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  validaCompaniaInmueble(cobertura: string, estatusTercero: number, tipoTercero: number): boolean {
    if (cobertura == '0' || cobertura == '2') {
      if (estatusTercero !== 2 && tipoTercero === 2) {
        return true;
      }
    }
    return false;
  }


  consultarPagosRecuperacionesIndividual(numeroLiga: number) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: this.detalleSiniestroBase.responsabilidad,
      numeroLiga: numeroLiga
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaRecuperacionesPagos(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.detalleRecuperacionPago = value.Resultado.RecuperacionPago[0];
        this.setFormulario();
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  setFormulario() {
    const nombreLesionado = this.detalleRecuperacionPago?.nombre_lesionado?.split("|");
    const coberturaTercero = this.cargaCoberturaAsegurado(this.seccion, this.catCoberturas);
    const claveCoberturaTercero = this.cargaIdCoberturaAsegurado(this.seccion, this.catCoberturas);
    this.formPagos.patchValue({
      tipoTercero: this.detalleRecuperacionPago?.tipo_tercero,
      descripcionTercero: this.detalleRecuperacionPago?.desc_tipo_tercero,
      coberturaTercero: coberturaTercero,
      claveCoberturaTercero:  claveCoberturaTercero,
      tipo: this.detalleRecuperacionPago?.tipo_pago,
      folio: this.detalleRecuperacionPago?.folio,
      subTipo: this.detalleRecuperacionPago?.subtipo_pago,
      importe: this.detalleRecuperacionPago?.importe ? this.detalleRecuperacionPago?.importe?.replace(/[$,]/g, "") : null,
      lesionado: this.detalleRecuperacionPago?.nombre_lesionado?.replace(/\|/g, " "),
      idLesionado: this.detalleRecuperacionPago?.id_lesiona,
      nombreLesionado: nombreLesionado ? nombreLesionado[0] : null,
      apellidoPaterno: nombreLesionado ? nombreLesionado[1] : null,
      apellidoMaterno: nombreLesionado ? nombreLesionado[2] : null,
      edad: this.detalleRecuperacionPago?.edad,
      tradicionalTipo: this.detalleRecuperacionPago.tradicional_tipo,
      idTercero: this.detalleRecuperacionPago?.id_tercero,
      subtipoPagoGarantia: this.detalleRecuperacionPago?.subtipo_pago_garantia,
      compania: this.detalleRecuperacionPago?.cve_cia_aseg,
      descripcionCompania: this.detalleRecuperacionPago?.desc_cia_aseg,
      coberturaIngreso: 0,
    })
  }

  cargaCoberturaAsegurado(tipoCliente: number, coberturas: any[]): string {
    let cobertura = this.detalleRecuperacionPago?.cve_cobertura; //REF FORM
     console.log(coberturas, 'coberturas',this.detalleRecuperacionPago)
    if (tipoCliente === 2 && coberturas.length) {
      for (const item of coberturas) {
        cobertura = item.cve_coberturak;
        if ([1, 2, 3, "1", "2", "3"].includes(cobertura)) {
          cobertura = cobertura == 1 ? 2 : cobertura == 2 ? 4 : 10;
          break;
        }
      }
    }
    return tipoCliente === 1 ? this.cargaDescripcionCobertura(Number(cobertura)): this.cargaDescripcionCobertura(Number(cobertura));
  }

  cargaIdCoberturaAsegurado(tipoCliente: number, coberturas: any[]): number {
    let cobertura = this.detalleRecuperacionPago?.cve_cobertura; 

    if (tipoCliente === 2 && coberturas.length) {
      for (const item of coberturas) {
        cobertura = item.cve_coberturak;
        if ([1, 2, 3, "1", "2", "3"].includes(cobertura)) {
          cobertura = cobertura == 1 ? 2 : cobertura == 2 ? 4 : 10;
          break;
        }
      }
    }
    return tipoCliente === 1 ? Number(cobertura): Number(cobertura);
  }

  cargaDescripcionCobertura(cobertura: number) {
    let descripcion = "";

    switch (cobertura) {
      case 0:
        descripcion = "SIN SEGURO";
        break;
      case 2:
        descripcion = "AMPLIA";
        break;
      case 4:
        descripcion = "LIMITADA";
        break;
      case 10:
        descripcion = "RC";
        break;
    }
    return descripcion;
  }

  validaGuardaActualizaRecuperacionPago(): void {
    const tipoCliente = this.seccion;
    const esPago = tipoCliente === 1;
    const tipoPago = this.formPagos.get('tipo')?.value;
    const idCompania = this.detalleRecuperacionPago?.cve_cia_aseg || 0;
    const sipac = this.detalleRecuperacionPago?.cve_cia_aseg_sipac || 0;

    let requeridos = false;
    let mensaje = '';

    // Validación de campos requeridos
    if (!this.formPagos.valid) {
      mensaje = 'Debe capturar los campos requeridos.';
      requeridos = true;
    }

    // Orden directa y pase médico
    if (this.formPagos.get('subTipo').value == 3 && this.formPagos.get('tipo').value == 10 && this.formPagos.get('lesionado').value == null) {
      mensaje = 'Debe especificar el lesionado ligado al pase médico.';
      requeridos = true;
    }

    if (!requeridos) {
      switch (tipoPago) {
        case '5': // SIPAC
          if (idCompania != 0) {
            if (sipac == 0) {
              requeridos = true;
              mensaje = 'No se puede recibir un sipac de una compañia fuera del convenio.';
            }
          } else {
            requeridos = true;
            mensaje = 'Debe especificar de qué compañía se está recibiendo la orden sipac.';
          }
          break;

        case '6': // Tradicional
          if (idCompania == 0) {
            requeridos = true;
            mensaje = 'Debe especificar de qué compañía se está recibiendo la orden tradicional.';
          }
          break;
      }
    }

    if (!requeridos) {
      this.guardaActualizaRecuperacionPagos(); // Lógica de envío o guardado
    } else {
      this.procesosComunesService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, mensaje);
      this.formPagos.markAllAsTouched();
    }
  }

  guardaActualizaRecuperacionPagos() {
    const tipoPago = this.formPagos.get('tipo').value;
    const subTipoPago = tipoPago == 9 ? this.formPagos.get('subtipoPagoGarantia').value : this.formPagos.get('subTipo').value;
    const nombreLesionado = `${this.formPagos.get('nombreLesionado').value || ''}|${this.formPagos.get('apellidoPaterno').value || ''}|${this.formPagos.get('apellidoMaterno').value || ''}`
    const tipoSeccion = this.seccion == 1;
    let reglaLesionado = this.formPagos.get('tipo').value == 6 ? this.formPagos.getRawValue().subTipo == 3 : false;
    let validaLesionado = tipoSeccion ? reglaLesionado : false;
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      servicio: "GuardaActualizaRecuperacionPago",
      origen: "Web",
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: this.detalleSiniestroBase.responsabilidad,
      numeroLiga: this.detalleRecuperacionPago.num_liga,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      idTercero: this.detalleRecuperacionPago.id_tercero,
      coberturaAsegurado: this.formPagos.get('claveCoberturaTercero').value,
      tipo: tipoPago,
      subTipo: subTipoPago ?? 0,
      tradicionalTipo: this.formPagos.get('tradicionalTipo').value,
      importe: this.formPagos.get('importe').value,
      compania: this.formPagos.get('compania').value, //this.detalleRecuperacionPago.cve_cia_aseg
      folio: this.formPagos.get('folio').value,
      id_lesionado: this.detalleRecuperacionPago.id_lesiona ?? this.formPagos.get('idLesionado').value,
      tipoTercero: this.formPagos.get('tipoTercero').value,
      cveCober: this.formPagos.get('coberturaIngreso').value
    }
    console.log(request, validaLesionado)
    // Y00-5499-2024
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.guardaActualizaRecuperacionPago(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesosComunesService.alertaGeneralComplemento(value.Exito ? 'Guardado!' : 'Aviso!', '', value.Exito ? 'success' : 'warning', false, true, `${value.Exito ? 'Se guardó/actualizó el pago o recuperación' : value.Mensaje}`);
        if (!validaLesionado) {
          this.eventosPagosRecuperaciones.emit({ nombre: 'ACTUALIZA_CONSULTA_TERCEROS', valor: true });
          this.regresaConsulta();
        } else {
          this.eventosPagosRecuperaciones.emit({ nombre: 'ACTUALIZA_TERCEROS', valor: { ...this.formPagos.getRawValue(), num_liga: value.Resultado.NumeroLiga, terceroSeleccionado: this.detalleRecuperacionPago, tipo : 1 } });
          return this.regresaConsulta();
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos guardar/actualizar el pago o recuperación.' }));
      },
    })
  }

  confirmaEliminacionPagoRecuperacion(pagoRecuperacion: RecuperacionPago) {
    this.procesosComunesService.alertaGeneralComplemento('Aviso!', '', 'question', true, true, `Está seguro que desea eliminar el registro?.</div>`).then(result => {
      if (result.isConfirmed) {
        this.eliminarPagoRecuperacion(pagoRecuperacion);
      }
    })
  }

  eliminarPagoRecuperacion(pagoRecuperacion: RecuperacionPago) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: this.detalleSiniestroBase.responsabilidad,
      numeroLiga: pagoRecuperacion.num_liga,
      tipo: pagoRecuperacion.tipo_pago,
      subTipo: pagoRecuperacion.subtipo_pago,
      id_tercero: pagoRecuperacion.id_tercero
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.eliminaRecuperacionPago(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        //Actualiza complemento si validacion true
        // this.eventosPagosRecuperaciones.emit({ nombre: 'ACTUALIZA_COMPLEMENTO', valor: this.formPagos.getRawValue() });
        this.eventosPagosRecuperaciones.emit({ nombre: 'ACTUALIZA_CONSULTA_TERCEROS', valor: this.formPagos.getRawValue() });
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos eliminar el pago o recuperación.' }));
      },
    })
  }
}
